<template>
  <div class="h-16 border-gray-dark border-b-2 pl-2 pb-2 pr-2">
    <div class="flex flex-row mt-2">
      <div class="flex flex-grow">
        <div class="flex flex-grow flex-row semi-bold">
          <span class="font-light text-grey-dark text-sm  mr-2">{{ sessionDate | formatDate }}</span>
          <router-link :to="{name:'training.summary',params :{id:sessionId}}">
            <span>{{ sessionTitle }}</span>
          </router-link>

          <div class="ml-2 mt-1 flex-grow">
            <div class="flex-grow">
              <div class="flex flex-row">
                <div
                  v-for="index in totalRed"
                  :key="index"
                  class="rounded h-4 w-2 border-black border-1 bg-red-700 "
                />
              </div>
              <div class="flex flex-row">
                <div
                  v-for="index in totalYellow"
                  :key="index"
                  class="rounded ml-1 h-4 w-2  border-black border- bg-yellow-600 "
                />
              </div>
            </div>
          </div>
          <span
            v-for="tag in emphasisTags"
            :key="tag.name"
            class="tag h-4"
          >{{ tag.value }}x{{ tag.name }}</span>
        </div>
      </div>
    </div>

    <div class="text-sm font-light mb-1 flex flex-row">
      <div class="change">
        <router-link :to="{name:'training.sessions.modify',params :{id:sessionId}}">
          <span class="mr-2"><i class="fas fa-edit" /> Ändern</span>
        </router-link>
      </div>
      <div class="team">
        <router-link :to="{name:'teams.detail',params:{id:teamId}}">
          <span class="font-light text-grey-dark text-sm">
            <i class="fas fa-users mr-1" /><span>{{ teamName }}</span>
          </span>
        </router-link>
      </div>

      <div class="presence">
        <router-link :to="{name:'training.sessions.presence',params:{id:sessionId}}">
          <span>
            <i class="far fa-list-alt mr-2" />Spieler
            <span class="p-tag mr-2">{{ participated.length }}</span>
          </span>
        </router-link>
      </div>
      <div class="option">
        <router-link :to="{name:'training.feedback',params:{id:sessionId}}">
          <i class="far fa-comment-dots mr-1" />Feedback
        </router-link>
      </div>

      <div class="option">
        <router-link :to="{name:'training.copy',params:{id:sessionId}}">
          <i class="fas fa-copy mr-1" />Kopieren
        </router-link>
      </div>
      <div class="option">
        <i
          class="text-orange fas fa-trash cursor-pointer  "
          @click="onRemove"
        /> Löschen
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SessionSmall',
    props: {
        totalRed: {
            type: Number,
            required: false
        },
        totalYellow: {
            type: Number,
            required: false
        },
        sessionId: {
            type: String,
            required: false
        },
        sessionTitle: {
            type: String,
            required: false
        },
        sessionDate: {
            type: String,
            required: false
        },

        teamId: {
            type: String,
            required: false
        },
        teamName: {
            type: String,
            required: false
        },
        emphasisTags: {
            type: Object,
            required: false
        },
        participated: {
            type: Array,
            required: false
        }

    },
    methods: {
        async onRemove () {
            this.$emit('remove', this.sessionId)
        }
    }
}
</script>

<style scoped>
  .change {
    width: 75px;
    height: 20px;
    overflow: hidden;
  }

  .team {
    width: 12rem;
    height: 20px;
    overflow: hidden;
  }

  .presence {
    width: 95px;
    height: 20px;
    overflow: hidden;
  }

  .option {
    margin-right: 4px;
    height: 20px;
  }

</style>